'use strict';

import CardsTemplate from './cards.html';
import TrendChart from '../trendChart/trendChart';
import './cards.scss';

export default angular
  .module('maestro.directives.components.cards', [
    TrendChart
  ])

  .directive('cards', function() {
    return {
      restrict: 'E',
      template: CardsTemplate,
      scope: {},
      controller: function($scope,
                           $q,
                           utils,
                           EditLocationDataProvider) {
        $scope.dataProvider = EditLocationDataProvider.instance;
        // angular.extend($scope, {});

        $scope.stateStatusColors = {
          0: 'green',
          1: 'orange',
          2: 'red'
        };

        init();

        // No code execution below this line
        // ---------------------------------

        function init() {
          $scope.loading = true;
          $q.all([
            $scope.dataProvider.locationCardsResource.init()
          ])
            .then(() => {
              initViewModel();

              $scope.$watch('dataProvider.locationCardsResource.value', () => {
                initViewModel();
              }, true);

              $scope.loading = false;
            }, (err) => {
              $scope.loading = false;
              // utils.handleApiError(err);
            });
        }

        function initViewModel() {
          $scope.cards = angular.copy($scope.dataProvider.locationCardsResource.value);
        }
      }
    };
  })

  .name;
